import { isEmpty, toUpper } from 'lodash';
import { USER_ID_KEY } from '../global/constants';
import { sessionGetItem } from './storage';
import { getLocalCountryLanguage } from './utils';

class DataDogEvent {
  constructor() {
    this.maxLimit = 50;
    this.count = 0;
    this.timer = '';
  }

  getUserDataForDataDog = () => {
    const userData = sessionGetItem(USER_ID_KEY) || {};
    const { localeCountry = '', localeLanguage = '' } = getLocalCountryLanguage();
    const country = toUpper(localeCountry);
    const language = toUpper(localeLanguage);
    const locale = `${localeLanguage}_${country}`;
    if (!isEmpty(userData)) {
      const { userId, firstName, lastName } = userData;
      const id = userId;
      const name = `${firstName} ${lastName}`;
      const decibelSessionId = window?.decibelInsight('getSessionId');
      return { id, name, country, language, locale, decibel_session_id: decibelSessionId };
    }
    return {
      id: 'Anonymous',
      name: 'Guest',
      country,
      language,
      locale,
      decibel_session_id: window?.decibelInsight('getSessionId'),
    };
  };

  setUserDataForDataDog = async () => {
    const config = this.getUserDataForDataDog();
    return window?.DD_RUM?.setUser(config);
  };

  callDataDogEvent = async () => {
    if (
      typeof window.DD_RUM !== 'undefined' &&
      typeof window.decibelInsight === 'function' &&
      typeof window.decibelInsight('getSessionId') !== 'undefined'
    ) {
      // to check data dog rum and decibel script is loaded or not
      await this.setUserDataForDataDog();
      clearTimeout(this.timer);
    } else if (typeof window.DD_RUM !== 'undefined' && this.count > this.maxLimit - 2) {
      // to check if decibel script is not loaded but data rum is loaded and run when count will remain 2 less than from maxLimit
      clearTimeout(this.timer);
      await this.setUserDataForDataDog();
    } else if (this.count <= this.maxLimit) {
      this.timer = setTimeout(() => {
        this.count = this.count + 1;
        this.callDataDogEvent().catch(() => clearTimeout(this.timer));
      }, 1000);
    } else {
      clearTimeout(this.timer);
    }
  };

  loadDataDogEvent = async () => {
    await this.callDataDogEvent();
  };
}

const dataDogEvent = new DataDogEvent();

export default dataDogEvent;
